<template>
  <v-dialog
    v-model="showModal"
    width="500"
    persistent
    content-class="mainModal"
  >
    <v-card class="cardModal" elevation="0">
      <div class="input-wrapper textAreaModal">
        <h2 class="titleSection text-center">Nueva Version Encontrada</h2>
          <p>Se ha detectado una nueva versión a utilizar. Es requerido actualizar</p>
      </div>
      <div class="d-flex align-center justify-center">
          <v-btn
            color="success"
            depressed
            @click="refresh()"
          >
            Actualizar
          </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
  import { CHECK_VERSION } from '@/store/actions/user'

  export default {
    props: {},
    data: () => ({
      newVersion: false
    }),
    computed: {
      showModal: function () {
        return this.newVersion || this.$store.state.user.newVersion
      }
    },
    methods: {
      refresh: () => {
        window.location.reload()
      }
    },
    created () {
      this.$store.dispatch(CHECK_VERSION).then((value) => {
        this.newVersion = value
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ReloadRequired.vue